//--- Common ---
// ElasticSearch
export const ES_URL = 'https://search-deliver-me-kts7eem5abkhyvqvhvaq223pim.ap-southeast-2.es.amazonaws.com';
export const ES_USERNAME = 'read_only';
export const ES_PASSWORD = 'ZXnRyv4f#.RZj{4a';


//--- Local ---
// export const HTTP_PROTOCOL = 'http';
// export const API_HOST = 'localhost:8000/api';       										// Local Api
// export const STATIC_HOST = 'localhost:8000/static'; 										// Local Static

// Zoho
// export const ZOHO_REDIRECT_URI = 'http://localhost:9000/zoho';
// export const ZOHO_CLIENT_ID = '1000.9N8A76PIJ2W7PJU6UIIL7JOZUWGPUN';
// export const ZOHO_CLIENT_SECRET = 'cfb889f8347f36c3f7c4a130fb3e82a4ae53006ff6';
// export const ZOHO_ORG_ID = '7000200810';


//--- DEV ---
// export const HTTP_PROTOCOL = 'https';
// export const API_HOST = 'dev.api.deliver-me.com.au/api';                 				// Dev Api
// export const S3_URL = 'dme-dev-api-static-public.s3-ap-southeast-2.amazonaws.com';
// export const STATIC_HOST = S3_URL;                          								// Dev Static

// Zoho
// export const ZOHO_REDIRECT_URI = 'https://dev.deliver-me.com.au/zoho';
// export const ZOHO_CLIENT_ID = '1000.ZVVPWDMH4SY3ZW6TDUI1011KO4HKNN';
// export const ZOHO_CLIENT_SECRET = '697d31c1bb2ac8e4f13a369262522cb72b5bd3af30';
// export const ZOHO_ORG_ID = '7000200810';


//--- PROD ---
export const HTTP_PROTOCOL = 'https';
export const API_HOST = 'prod.api.deliver-me.com.au/api';              					// Prod Api
export const S3_URL = 'dme-pod-api-static.s3-ap-southeast-2.amazonaws.com';
export const STATIC_HOST = S3_URL;                       								// Prod Static

// Zoho
// export const ZOHO_REDIRECT_URI = 'https://deliver-me.com.au/zoho';
// export const ZOHO_CLIENT_ID = '1000.42ANMURFOIIQP8GFPSLVHH63K5EYPN';
// export const ZOHO_CLIENT_SECRET = 'f306eba52bb0987d8620e0821e0421ffd6995c0b18';
// export const ZOHO_ORG_ID = '7000200810';



// WEBPACK FOOTER //
// ./src/config.js